module.exports = __webpack_public_path__ + "img/Speaker=Michelle Qin.dd839ac1.png";